import axios from "./axios_client";
import { getPreviousAndWeekLaterDates } from "../utils/date";
import { setCurrentWeather, setWeatherStats } from "../reducers/MapSlice";
import { toast } from "react-toastify";
/**
 * weather data requests from open-meteo are defined here
 */
//https://api.open-meteo.com/v1/forecast?latitude=52.52&longitude=13.41&daily=temperature_2m_max,temperature_2m_min,sunrise,sunset,precipitation_sum,rain_sum,snowfall_sum,windspeed_10m_max&timezone=Africa%2FCairo
//https://archive-api.open-meteo.com/v1/archive?latitude=52.52&longitude=13.41&start_date=2023-01-23&end_date=2023-02-22&daily=temperature_2m_max,temperature_2m_min,sunrise,sunset,precipitation_sum,snowfall_sum,windspeed_10m_max&timezone=Africa%2FCairo
export const getWeatherData = async (
  dispatch,
  t,
  datePickerTimeFrom,
  datePickerTimeTo,
  coord
) => {
  const { lat, lng } = coord;
  const { yesterday, weekLater, currentDate } = getPreviousAndWeekLaterDates();
  const start = Date.parse(datePickerTimeFrom);
  const end = Date.parse(datePickerTimeTo);

  const id = toast.loading(t("wait"));
  //call forecast api
  const forecastRes = await getWeatherForcastData({
    lat,
    lng,
  });
  if (forecastRes.data) {
    let cWeatherObj = {};
    for (let key in forecastRes.data.daily) {
      cWeatherObj[key] = forecastRes.data.daily[key][0]; //select first entries only which is current data in forecast api
    }
    dispatch(setCurrentWeather(cWeatherObj));
    //
  }

  //dates between 1960 - yesterday
  //show archive data only in stats
  if (end <= yesterday) {
    const histoRes = await getWeatherHistoricalData({
      start_date: datePickerTimeFrom,
      end_date: datePickerTimeTo,
      lat,
      lng,
    });
    let weatherStatsObj = {};
    console.log("hist", histoRes);
    for (let key in histoRes.data.daily) {
      weatherStatsObj[key] = histoRes.data.daily[key];
    }
    dispatch(setWeatherStats(weatherStatsObj));
  }

  //dates includes history + today's date
  //append archive + forcast api
  if (start <= yesterday && end >= currentDate) {
    const histoRes = await getWeatherHistoricalData({
      start_date: datePickerTimeFrom,
      end_date: yesterday.toISOString().slice(0, 10),
      lat,
      lng,
    });
    let weatherStatsObj = {};
    console.log("forcast", histoRes);
    for (let key in histoRes.data.daily) {
      weatherStatsObj[key] = [
        ...histoRes.data.daily[key],
        ...forecastRes.data.daily[key],
      ];
    }
    dispatch(setWeatherStats(weatherStatsObj));
  }

  //datePickerTimeFrom >= today's date
  //call forcast only
  if (start >= currentDate) {
    let weatherStatsObj = {};
    for (let key in forecastRes.data.daily) {
      weatherStatsObj[key] = forecastRes.data.daily[key];
    }
    dispatch(setWeatherStats(weatherStatsObj));
  }
  toast.update(id, {
    render: t("Map.weather_success"),
    type: "success",
    isLoading: false,
    autoClose: 3000,
    closeButton: true,
    closeOnClick: true,
  });
};
export const getWeatherHistoricalData = (params) => {
  const { lat, lng, start_date, end_date } = params;
  return axios.get(
    `https://archive-api.open-meteo.com/v1/archive?latitude=${lat}&longitude=${lng}&start_date=${start_date}&end_date=${end_date}&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,snowfall_sum,windspeed_10m_max&timezone=Africa%2FCairo`
  );
};

export const getWeatherForcastData = (params) => {
  const { lat, lng } = params;
  return axios.get(
    `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&daily=temperature_2m_max,temperature_2m_min,precipitation_sum,rain_sum,snowfall_sum,windspeed_10m_max&timezone=Africa%2FCairo`
  );
};
